import * as React from 'react'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import Review from 'modules/reviews/store/models/v2/Review'

import reviews from '../store/collections/v2/reviews'

export function useReview(formId: string | undefined): {
  loading: boolean
  review: Review | undefined
} {
  const [review, setReview] = React.useState<Review>()
  const { loading } = useAsyncData(async () => {
    if (!formId) return

    const review = await Review.fetch({ id: formId })

    const reviewFromCollection = await reviews.find({ id: Number(formId) })

    if (review && reviewFromCollection) await reviews.remove(Number(formId))
    if (review) reviews.add(review)
    setReview(review)
  }, [formId])

  return {
    loading,
    review: review,
  }
}
